// i18n.js
import i18n from "i18next";
import { initReactI18next } from "react-i18next";

// Importa le traduzioni
const resources = {
  en: {
    translation: {
      chat_starting_message:
        "Ciao! 😊 It's great to see you here. How can I assist you today? If you have a specific application or problem in mind, feel free to share an overview, and we can start exploring it together!",
      chat_ready_to_generate:
        "If you are satisfied with the current description and wish to stop making further changes, you can generate the code by pressing the button below.",
      start_discussing_your_idea: "Start discussing your idea",
      chat_generate_code: "Generate",
      chat_generation_system_prompt:
        "Your request is being processed. The contract will appear in the side panel shortly.",
      chat_input_text: "Type your message...",
      home: "Home",
      history: "History",
      about: "About",
      generating_code: "Generating code...",
      no_more_seats_title: "⚠️ You've Reached Your Free Contract Limit",
      authentication_error:
        "⚠️ You've some problem with your token, please contact the assistance!",
      no_more_seats_description:
        "You've successfully run 5 generations of smart contract with AI Kode Sherpa!",
      no_more_seats_description2:
        "🎉 Want more? We'd love to keep you going! 🚀",
      no_more_seats_description3:
        "Click below to request more free seats, and our team will reach out to assist you.",
      no_more_seats_button: "Request More Free Seats",
      seats_request_success_title:
        "Thank you, your request was successfully processed.",
      seats_request_success_description:
        "You will be contacted by one of our team members shortly.",
      contact_support: "Contact Support",
      support_email_label: "Email",
      support_discord_label: "Discord",
      create_account: "Create an account",
      start_coding: "Start coding with Kode Sherpa",
      signup_tagline: "Create a free account · No credit card · Takes ~30 seconds",
      go_back: "Go back",
      sign_in_with: "Sign in with",
      sign_up_with: "Sign up with",
      sign_in: "Sign in",
      sign_up: "Sign up",
      already_have_account: "Already have an account?",
      not_have_account: "Don't have an account?",
      or: "Or",
      accept_terms_and_privacy_policy: "Accept ",
      terms_of_service: "Terms of Service",
      privacy_policy: "Privacy Policy",
      loading: "Loading...",
      send: "Send",
      close: "Close",
      verify: "Verify",
      resend: "Resend",
      forgot_password: "Forgot password?",
      reset_password: "Reset password",
      enter_email_to_reset: "Enter your email to receive a verification code",
      send_reset_code: "Send Reset Code",
      enter_reset_code: "Enter the verification code",
      verification_code_from_email: "Code received by email",
      enter_code_sent_to_email: "Enter the code we sent to your email",
      choose_new_password: "Choose a new password that meets the requirements below",
      new_password: "New password",
      confirm_new_password: "Confirm new password",
      verification_code: "Enter the verification code",
      reset_code_sent: "Reset code sent",
      reset_password_after_failed_attempts:
        "Multiple sign-in attempts failed. Please reset your password or try using Google signin",
      reset_password_technical_required:
        "To ensure compatibility with the new release, please reset your password by entering the verification code sent to your email. This is a planned technical upgrade, not an error.",
      please_enter_email: "Please enter your email",
      please_enter_code_and_password: "Please enter the code and password",
      password_reset_success: "Password reset successfully",
      user_does_not_exist: "User does not exist",
      error_during_password_reset: "An error occurred during password reset. Please try again.",
      created_at: "Created at",
      last_update: "Last update",
      open_chat: "Open Chat",
      open_project: "Open Project",
      no_items_found: "No items found",
      loading_more_items: "Loading items...",
      new_chat: "New Chat",
      new_project: "New Project",
      current_project: "Current Project",
      templates: "Templates",
      projects: "Projects",
      profile: "Profile",
      my_projects: "My Projects",
      search_projects_placeholder: "Search projects by name or description...",
      view_details: "View details →",
      summary: "Summary",
      created: "Created",
      updated: "Updated",
      project_id: "Project ID",
      open_studio: "Open Studio",
      tokens_used: "tokens used",
      tokens_generated: "tokens generated",
      chat_tokens: "Chat Tokens",
      generated_tokens: "Generated Tokens",
      go_to_last_message: "Go to last message",

      // Root.tsx strings
      loading_please_wait: "Loading, please wait...",
      oops: "Oops!",
      unexpected_error: "An unexpected error occurred.",
      page_not_found: "The requested page could not be found.",
      error: "Error",

      // Profile page
      profile_loading: "Loading your profile...",
      profile_data_updating: "Data is being updated...",
      profile_error_title: "Error Loading Profile",
      profile_retry: "Retry",
      profile_title: "Account Profile",
      profile_subtitle:
        "Manage your subscription, view token usage, and update your account settings.",

      // LoginModal strings
      sign_in_to_continue: "Sign in to continue",
      create_account_or_sign_in:
        "Create an account or sign in to send messages",
      sign_in_button: "Sign In",
      sign_up_for_free: "Sign up for free",

      // CodeEditor strings
      undo: "Undo",
      redo: "Redo",
      copy_to_clipboard: "Copy to Clipboard",
      download_project: "Download Project",
      open_in_remix_ide: "Open in Remix IDE",
      compile_code: "Compile Code",
      compile_project: "Compile Project",
      generate_unit_tests: "Generate Unit Tests",
      updating_code: "Updating code",
      feature_not_available:
        "This feature is not available in your current plan. Upgrade to access this feature.",
      locked_file_read_only: "This file is locked and cannot be edited.",
      editor_read_only: "Editor is read-only.",

      // CompilationModal strings
      compiling: "Compiling...",
      compilation_logs: "Compilation logs:",
      fix_errors: "Fix Errors",
      fixing: "Fixing...",
      no_compilation_status: "No compilation status",
      no_errors_found: "No errors found",
      fix_errors_failed:
        "I could not fix all errors. Please check the code and fix the errors manually.",

      // UnitTestResultsModal strings
      generating_unit_tests: "Generating unit tests...",
      this_may_take_moments: "This may take a few moments",
      to_be_tested: "To be tested",
      unit_test_results: "Unit Test Results",
      total_tests: "Total Tests",
      passed: "Passed",
      failed: "Failed",
      skipped: "Skipped",
      excellent: "Excellent",
      good: "Good",
      needs_improvement: "Needs Improvement",
      code_coverage: "Code Coverage",
      statements: "Statements",
      branches: "Branches",
      functions: "Functions",
      lines: "Lines",
      execution_time: "Execution Time",
      warnings: "Warnings",
      recommendations: "Recommendations",
      generated_test_code: "Generated Test Code:",
      download: "Download",

      // DownloadConfirmationModal strings
      download_hardhat_project: "Download Hardhat Project",
      download_project_description:
        "Download a pre-configured Hardhat project folder with the complete setup to deploy and test your contract using one of the following options:",
      code_existing_tests: "Code + Existing tests",
      code_new_tests: "Code + New tests",
      code_simplified_tests: "Code + Simplified tests",
      cancel: "Cancel",
      download_error: "Download Error",
      try_again: "Try Again",
      download_generated_correctly: "Download Generated Correctly!",
      download_success_message:
        "Your download has been generated correctly. Choose where to save it.",
      click_outside_to_close:
        "Click outside the modal to close and check your download.",
      preparing_download: "Preparing Download...",
      preparing_download_message:
        "Please wait while we prepare your project for download",
      download_will_start_automatically:
        "Download will start automatically once tests are ready.",

      // HistoryComponent strings
      no_summary_available: "No summary available.",

      // Notification strings
      hidden_notifications: "hidden notifications",
      studio_autosave_failed: "Failed to auto-save file",
      studio_create_file_failed: "Failed to create file",
      studio_create_folder_failed: "Failed to create folder",
      studio_delete_node_failed: "Failed to delete file",
      studio_rename_node_failed: "Failed to rename file",
      studio_move_node_failed: "Failed to move file",

      // SignInSignUpPage strings
      ai_kode_sherpa_logo: "AI Kode Sherpa Logo",
      name_example: "name@example.com",
      password: "Password",
      enter_verification_code: "Enter Verification Code",
      error_resetting_password: "An error occurred while resetting password",
      error_confirming_reset: "An error occurred while confirming reset",
      change_password_required: "Change Password Required",
      enter_new_password: "Please enter a new password",
      please_enter_new_password: "Please enter a new password",
      change_password: "Change Password",
      error_changing_password: "An error occurred while changing your password",
      password_change_denied:
        "Password change was denied. Please check your password requirements.",
      invalid_password:
        "Password does not meet requirements. Please use a stronger password.",
      password_requirements: "Password requirements:",
      password_min_length: "At least 8 characters",
      password_require_uppercase: "One uppercase letter",
      password_require_lowercase: "One lowercase letter",
      password_require_number: "One number",
      password_require_special: "One special character",
      password_missing_requirements:
        "Your password is missing the following requirements:",
      incorrect_credentials: "Incorrect email or password.",
      account_exists_reset_password:
        "An account with this email already exists. Please sign in with email and password or Google.",
      code_resent: "Verification code resent",
      resend_verification_code: "Resend Verification Code",
      check_email_for_code: "Check your email for the verification code",
      auth_failed_try_again: "Authentication failed. Please try again.",
      sign_in_google_failed: "Sign in with Google failed. Please try again.",
      sign_up_google_failed: "Sign up with Google failed. Please try again.",
      oauth_error: "Sign-in with Google failed. Please try again.",
      session_error_sign_in_again: "Session error. Please sign in again.",
      error_during_sign_in: "An error occurred during sign in. Please try again.",
      captcha_not_available: "Verification could not load. Please refresh and try again.",
      error_during_sign_up: "An error occurred during sign up. Please try again.",
      auth_failed_sign_in_manually: "Authentication failed. Please try signing in manually.",
      error_during_verification: "An error occurred during verification. Please try again.",
      wrong_verification_code: "The verification code is incorrect. Please try again.",
      verification_code_expired: "The verification code has expired. Please request a new one.",
      error_resending_code: "Error resending verification code. Please try again.",
      error_contact_support: "An error occurred (error code: {{errorCode}}). Please contact support.",
      password_reset_success_sign_in: "Password reset successful. Please sign in with your new password.",
      oauth_domain_not_configured: "Sign-in with Google is not available. Please try again later.",
      attempt_remaining_before_reset: "1 attempt remaining before password reset option.",
      attempts_remaining_before_reset: "{{count}} attempts remaining before password reset option.",

      // ErrorPage strings
      go_to_login_page: "Go to login page",

      // Sidebar strings
      toggle_menu: "Toggle menu",
      ai_kode_sherpa: "AI Kode Sherpa",
      astrakode_logo: "Astrakode Logo",
      astrakode_favicon: "Astrakode Favicon",

      // MainLayout strings
      logout: "Logout",
      toggle_code_editor: "Toggle Code Editor",
      error_during_generation: "Error during the generation, please try again!",
      not_compiled: "Not compiled",
      generation_failed: "Generation failed",
      starting_code_generation: "Starting code generation...",
      generated: "Generated",
      idle: "Idle",
      fixing_errors_status: "Fixing errors...",
      failed_to_generate_project:
        "Failed to generate project. Please try again.",
      error_occurred_generating_unit_tests:
        "An error occurred while generating unit tests",
      error_occurred_executing_unit_tests:
        "An error occurred during test execution",
      loading: "Loading",

      // ChatComponent strings
      assistant_avatar: "Assistant Avatar",

      // Root.tsx strings
      app_title: "AI Kode Sherpa",

      // About page strings
      go_to_demo: "← Go to demo",
      about_react_router_contacts: "About React Router Contacts",
      demo_description:
        "This is a demo application showing off some of the powerful features of React Router, including dynamic routing, nested routes, loaders, actions, and more.",
      features: "Features",
      explore_demo: "Explore the demo to see how React Router handles:",
      data_loading_mutations:
        "Data loading and mutations with loaders and actions",
      nested_routing: "Nested routing with parent/child relationships",
      url_based_routing: "URL-based routing with dynamic segments",
      pending_optimistic_ui: "Pending and optimistic UI",
      learn_more: "Learn More",
      check_documentation: "Check out the official documentation at",
      reactrouter_link: "reactrouter.com",
      learn_more_description:
        "to learn more about building great web applications with React Router.",

      // Additional strings
      success_rate: "Success Rate",
      compilation_results: "Compilation Results",
      open_compilation_results: "Open Compilation Results",
      open_test_results: "Open Test Results",
      this_may_take_a_few_moments: "This may take a few moments",
      fix_compilation_errors: "Fix compilation errors",
      contract_compilation_failed: "Contract does not compile",
      fixing_errors: "Fixing errors...",
      download_test_code: "Download test code",

      // Tool descriptions
      tool_generateCode_description:
        "Generating the code based on your specifications",
      tool_generateContract_description:
        "Generating the code based on your specifications",
      tool_updateRequirements_description:
        "Updating the project requirements and specifications",
      tool_readFileTool_description: "Reading project files",
      tool_writeFileTool_description: "Creating project files",
      tool_updateFileTool_description: "Updating project files",
      tool_deleteNodeTool_description: "Deleting project files or folders",
      tool_moveNodeTool_description: "Moving project files or folders",
      tool_listDirectoryTool_description: "Reading the project structure",
      tool_generateDeploymentInstructions_description:
        "Generating the deployment instructions for the contract",
      tool_updateCode_description:
        "Updating the contract code based on your specifications",
      tool_retrieveContractCode_description: "Reading the contract code",
      tool_retrieveRequirements_description: "Reading the requirements",
      tool_retrieveTests_description: "Reading the tests",
      tool_working_description: "Working on your request",

      // Test strings
      generating_tests: "Generating tests...",
      executing_tests: "Executing tests...",
      generating_tests_for: "Generating tests for",
      running_tests_for: "Running tests for",
      test_generation_failed:
        "Test generation failed, please try again later. If the problem persists, please contact the support.",
      test_execution_failed:
        "Test execution failed, please try again later. If the problem persists, please contact the support.",
      coverage_execution_failed:
        "Code coverage collection failed, but test execution results are still available.",
      test_execution_timeout:
        "Test execution timed out. The tests are taking too long to complete. Please try again with simpler tests or contact support.",
      test_compilation_failed:
        "Test compilation failed. There might be syntax errors in the generated tests. Please try again or contact support.",
      test_missing_dependencies:
        "Test execution failed due to missing dependencies. Please try again or contact support.",
      test_exec_fail_missing_permissions:
        "Test execution failed due to permission issues. Please try again or contact support.",
      test_exec_fail_memory_constraints:
        "Test execution failed due to memory constraints. Please try again with simpler tests or contact support.",
      test_exec_fail_unexpectedly:
        "Test execution failed unexpectedly. Please try again later or contact support if the issue persists.",
      error_retrieving_tests:
        "There has been an error retrieving tests. Please try again.",

      // Plan issues strings
      upgrade_to_download: "Upgrade to a premium plan to download projects",
      upgrade_to_generate_tests: "Upgrade to a premium plan to generate tests",
      generate_tests_for_file: "Generate tests for {{file}}",
      regenerate_tests_for_file: "Regenerate tests for {{file}}",
      select_solidity_file_to_generate:
        "Select a Solidity file to generate tests",
      tests_will_target: "Tests will be generated for",
      active_contract: "Active contract",
      tests_for: "Generate tests for",
      regenerate: "Regenerate",
      generate: "Generate",
      generate_for_file: "Generate for {{file}}",
      no_file_selected: "No file selected",
      context_mismatch_warning:
        "Active editor file ({{active}}) differs from the file these results were generated for.",
      upgrade_plus_title: "Unlock Premium Features",
      upgrade: "Upgrade",
      upgrade_plan: "Upgrade to Plus",
      // Token / subscription modals
      token_limit_exceeded: "Token limit exceeded",
      insufficient_tokens: "Insufficient Tokens",
      insufficient_tokens_description:
        "You don't have enough tokens to complete this operation.",
      tokens_needed: "Tokens Needed:",
      tokens_remaining: "Tokens Remaining:",
      upgrade_plus_get: "Upgrade to Plus Plan and get:",
      tokens_per_month: "3M tokens/month",
      ten_x_more: "10x more than the free plan!",
      upgrade_now: "Upgrade Now",
      token_limit_exceeded_title: "Token Limit Exceeded",
      token_limit_exceeded_message:
        "Token limit exceeded. Upgrade your plan or wait for the reset date to continue.",
      used: "Used:",
      used_label: "Used",
      limit: "Limit:",
      remaining: "Remaining:",
      remaining_label: "Remaining",
      resets_on: "Resets on:",
      upgrade_plan: "Upgrade Plan",
      billing_subscription: "Billing & Subscription",
      current_plan: "Current Plan",
      account_email: "Account Email",
      plan_valid_until: "Plan valid until",
      next_billing_date: "Next Billing Date",
      downgrading_to: "Downgrading to",
      plan_status: "Plan Status",
      unlimited: "Unlimited",
      service_plan_unlimited: "Service plan with unlimited access",
      service_plan: "Service Plan",
      free_plan: "Free Plan",
      plus_plan: "Plus Plan",
      upgrade_to_plus: "Upgrade to Plus",
      manage_subscription: "Manage Subscription",
      your_plan_includes: "Your Plan Includes:",
      service_plan_managed: "Service plan managed administratively",
      upgrade_to_plus_plan: "Upgrade to Plus Plan",
      monthly: "Monthly",
      yearly: "Yearly",
      save_20: "Save 20%",
      tax_at_checkout: "Tax calculated at checkout",
      million_tokens_per_month: "15 million tokens per month",
      advanced_code_generation: "Advanced code generation",
      enhanced_testing: "Enhanced testing capabilities",
      priority_support: "Priority support",
      cancel_anytime: "Cancel anytime",
      processing: "Processing...",
      continue_to_checkout: "Continue to Checkout",
      token_usage: "Token Usage",
      close_modal: "Close modal",
      total_limit: "Total Limit",
      tokens_label: "tokens",
      status_label: "Status: ",
      token_limit_warning_exceeded:
        "You have exceeded your token limit. Please upgrade your plan or wait for the reset date.",
      token_limit_warning_low:
        "You are running low on tokens. Consider upgrading your plan.",
      token_limit_warning_most:
        "You have used most of your token allocation this month.",
      delete_project: "Delete Project",
      project_deleted: "Project Deleted",
      project_deleted_success: "The project has been successfully removed.",
      delete_failed: "Delete Failed",
      delete_failed_error: "An error occurred while deleting the project. Please try again.",
      confirm_delete_project: "Are you sure you want to delete this project? This action cannot be undone.",
    },
  },
  it: {
    translation: {
      chat_starting_message:
        "Ciao! 😊 È bello vederti qui. Come posso aiutarti oggi? Se hai in mente un'applicazione o un problema specifico, sentiti libero di condividere una panoramica e possiamo iniziare a esplorarlo insieme!",
      chat_ready_to_generate:
        "Se sei soddisfatto della descrizione attuale e non vuoi più apportare modifiche, puoi generare il codice premendo il pulsante qui sotto.",
      start_discussing_your_idea: "Inizia a discutere la tua idea",
      chat_generate_code: "Genera",
      chat_generation_system_prompt:
        "La richiesta è in elaborazione. Il contratto apparirà nel pannello laterale in pochi istanti.",
      chat_input_text: "Scrivi un messaggio...",
      home: "Home",
      history: "Cronologia",
      about: "Chi siamo",
      generating_code: "Generazione in corso...",
      no_more_seats_title:
        "⚠️ Hai raggiunto il limite gratuito per la generazione di contratti",
      authentication_error:
        "⚠️ C'è un problema con il tuo token, contatta l'assistenza!",
      no_more_seats_description:
        "Hai eseguito 5 generazioni di Smart Contract con AI Kode Sherpa!",
      no_more_seats_description2:
        "🎉 Vuoi più? Ci piacerebbe aiutarti ulteriormente! 🚀",
      no_more_seats_description3:
        "Clicca qui sotto per richiedere più posti gratuiti e il nostro team ti contatterà per aiutarti.",
      no_more_seats_button: "Richiedi più posti gratuiti",
      seats_request_success_title:
        "Grazie, la tua richiesta è stata processata con successo.",
      seats_request_success_description: "Ti risponderemo il prima possibile.",
      contact_support: "Contatta il supporto",
      support_email_label: "Email",
      support_discord_label: "Discord",
      create_account: "Crea un account",
      start_coding: "Inizia a programmare con Kode Sherpa",
      signup_tagline: "Crea un account gratuito · Nessuna carta richiesta · Circa 30 secondi",
      go_back: "Indietro",
      sign_in_with: "Accedi con",
      sign_up_with: "Registrati con",
      sign_in: "Accedi",
      sign_up: "Registrati",
      already_have_account: "Hai già un account?",
      not_have_account: "Non hai un account?",
      or: "Oppure",
      accept_terms_and_privacy_policy: "Accetto ",
      terms_of_service: "Termini di Servizio",
      privacy_policy: "Privacy Policy",
      loading: "Caricamento...",
      send: "Invia",
      close: "Chiudi",
      verify: "Verifica",
      resend: "Rispedisci",
      forgot_password: "Hai dimenticato la password?",
      reset_password: "Reimposta password",
      enter_email_to_reset:
        "Inserisci la tua email per ricevere un codice di verifica",
      send_reset_code: "Invia codice di reset",
      enter_reset_code: "Inserisci il codice di verifica",
      verification_code_from_email: "Codice ricevuto via email",
      enter_code_sent_to_email: "Inserisci il codice che ti abbiamo inviato via email",
      choose_new_password: "Scegli una nuova password che rispetti i requisiti sotto",
      new_password: "Nuova password",
      confirm_new_password: "Conferma nuova password",
      verification_code: "Inserisci il codice di verifica",
      reset_code_sent: "Codice di reset inviato",
      incorrect_credentials: "Email o password non corretti.",
      account_exists_reset_password:
        "Esiste già un account con questa email. Accedi con email e password o Google.",
      code_resent: "Codice di verifica inviato di nuovo",
      resend_verification_code: "Rispedisci codice di verifica",
      check_email_for_code: "Controlla la tua email per il codice di verifica",
      auth_failed_try_again: "Autenticazione fallita. Riprova.",
      sign_in_google_failed: "Accesso con Google fallito. Riprova.",
      sign_up_google_failed: "Registrazione con Google fallita. Riprova.",
      oauth_error: "Accesso con Google fallito. Riprova.",
      session_error_sign_in_again: "Errore di sessione. Accedi di nuovo.",
      error_during_sign_in: "Si è verificato un errore durante l'accesso. Riprova.",
      captcha_not_available: "Verifica non disponibile. Aggiorna la pagina e riprova.",
      error_during_sign_up: "Si è verificato un errore durante la registrazione. Riprova.",
      auth_failed_sign_in_manually: "Autenticazione fallita. Accedi manualmente.",
      error_during_verification: "Si è verificato un errore durante la verifica. Riprova.",
      wrong_verification_code: "Il codice di verifica non è corretto. Riprova.",
      verification_code_expired: "Il codice di verifica è scaduto. Richiedine uno nuovo.",
      error_resending_code: "Errore nell'invio del codice di verifica. Riprova.",
      error_contact_support: "Si è verificato un errore (codice errore: {{errorCode}}). Contatta l'assistenza.",
      password_reset_success_sign_in: "Password reimpostata. Accedi con la nuova password.",
      oauth_domain_not_configured: "Accesso con Google non disponibile. Riprova più tardi.",
      attempt_remaining_before_reset: "1 tentativo rimasto prima dell'opzione di reset password.",
      attempts_remaining_before_reset: "{{count}} tentativi rimasti prima dell'opzione di reset password.",
      reset_password_after_failed_attempts:
        "Abbiamo notato diversi tentativi di accesso falliti. Reimposta la password o prova ad accedere con Google",
      reset_password_technical_required:
        "Per garantire la compatibilità con la nuova versione, reimposta la password inserendo il codice di verifica inviato alla tua email. Si tratta di un aggiornamento tecnico pianificato, non di un errore.",
      please_enter_email: "Inserisci la tua email",
      please_enter_code_and_password: "Inserisci il codice e la password",
      password_reset_success: "Password reimpostata con successo",
      user_does_not_exist: "L'utente non esiste",
      error_during_password_reset: "Si è verificato un errore durante il reset della password. Riprova.",
      created_at: "Creato il",
      last_update: "Ultimo aggiornamento",
      open_chat: "Apri Chat",
      open_project: "Apri Progetto",
      no_items_found: "Nessuna elemento trovato",
      loading_more_items: "Caricamento elementi...",
      new_chat: "Nuova Chat",
      new_project: "Nuovo Progetto",
      current_project: "Progetto Corrente",
      templates: "Template",
      projects: "Progetti",
      profile: "Profilo",
      my_projects: "I Miei Progetti",
      search_projects_placeholder: "Cerca progetti per nome o descrizione...",
      view_details: "Visualizza dettagli →",
      summary: "Riassunto",
      created: "Creato",
      updated: "Aggiornato",
      project_id: "ID Progetto",
      open_studio: "Apri Studio",
      tokens_used: "token utilizzati",
      tokens_generated: "token generati",
      chat_tokens: "Token Chat",
      generated_tokens: "Token Generati",
      go_to_last_message: "Vai all'ultimo messaggio",

      // Root.tsx strings
      loading_please_wait: "Caricamento, attendere prego...",
      oops: "Ops!",
      unexpected_error: "Si è verificato un errore imprevisto.",
      page_not_found: "La pagina richiesta non è stata trovata.",
      error: "Errore",

      // Profile page
      profile_loading: "Caricamento del profilo...",
      profile_data_updating: "I dati stanno venendo aggiornati...",
      profile_error_title: "Errore nel caricamento del profilo",
      profile_retry: "Riprova",
      profile_title: "Profilo account",
      profile_subtitle:
        "Gestisci l'abbonamento, visualizza l'utilizzo dei token e aggiorna le impostazioni dell'account.",

      // LoginModal strings
      sign_in_to_continue: "Accedi per continuare",
      create_account_or_sign_in:
        "Crea un account o accedi per inviare messaggi",
      sign_in_button: "Accedi",
      sign_up_for_free: "Registrati gratuitamente",

      // CodeEditor strings
      undo: "Annulla",
      redo: "Ripeti",
      copy_to_clipboard: "Copia negli appunti",
      download_project: "Scarica Progetto",
      open_in_remix_ide: "Apri in Remix IDE",
      compile_code: "Compila Codice",
      compile_project: "Compila Progetto",
      generate_unit_tests: "Genera Test Unitari",
      updating_code: "Aggiornamento codice",
      feature_not_available:
        "Questa funzionalità non è disponibile nel tuo piano attuale. Aggiorna per accedere a questa funzionalità.",
      locked_file_read_only: "Questo file e bloccato e non puo essere modificato.",
      editor_read_only: "L'editor e in sola lettura.",

      // CompilationModal strings
      compiling: "Compilazione...",
      compilation_logs: "Log di compilazione:",
      fix_errors: "Correggi Errori",
      fixing: "Correzione...",
      no_compilation_status: "Nessuno stato di compilazione",
      no_errors_found: "Nessun errore trovato",
      fix_errors_failed:
        "Non sono riuscito a correggere tutti gli errori. Controlla il codice e correggi gli errori manualmente.",

      // UnitTestResultsModal strings
      generating_unit_tests: "Generazione test unitari...",
      this_may_take_moments: "Potrebbe richiedere alcuni minuti",
      to_be_tested: "Da testare",
      unit_test_results: "Risultati Test Unitari",
      total_tests: "Test Totali",
      passed: "Passati",
      failed: "Falliti",
      skipped: "Saltati",
      excellent: "Eccellente",
      good: "Buono",
      needs_improvement: "Necessita Miglioramenti",
      code_coverage: "Copertura del Codice",
      statements: "Istruzioni",
      branches: "Rami",
      functions: "Funzioni",
      lines: "Righe",
      execution_time: "Tempo di Esecuzione",
      warnings: "Avvertimenti",
      recommendations: "Raccomandazioni",
      generated_test_code: "Codice Test Generato:",
      download: "Scarica",

      // DownloadConfirmationModal strings
      download_hardhat_project: "Scarica Progetto Hardhat",
      download_project_description:
        "Scarica una cartella del progetto Hardhat preconfigurata con la configurazione completa per distribuire e testare il tuo contratto utilizzando una delle seguenti opzioni:",
      code_existing_tests: "Codice + Test esistenti",
      code_new_tests: "Codice + Nuovi test",
      code_simplified_tests: "Codice + Test semplificati",
      cancel: "Annulla",
      download_error: "Errore Download",
      try_again: "Riprova",
      download_generated_correctly: "Download Generato Correttamente!",
      download_success_message:
        "Il tuo download è stato generato correttamente. Scegli dove salvarlo.",
      click_outside_to_close:
        "Clicca fuori dal modale per chiudere e controllare il download.",
      preparing_download: "Preparazione Download...",
      preparing_download_message:
        "Attendere mentre prepariamo il progetto per il download",
      download_will_start_automatically:
        "Il download inizierà automaticamente quando i test saranno pronti.",

      // HistoryComponent strings
      no_summary_available: "Nessun riassunto disponibile.",

      // Notification strings
      hidden_notifications: "notifiche nascoste",
      studio_autosave_failed: "Salvataggio automatico del file non riuscito",
      studio_create_file_failed: "Creazione file non riuscita",
      studio_create_folder_failed: "Creazione cartella non riuscita",
      studio_delete_node_failed: "Eliminazione file non riuscita",
      studio_rename_node_failed: "Rinomina file non riuscita",
      studio_move_node_failed: "Spostamento file non riuscito",

      // SignInSignUpPage strings
      ai_kode_sherpa_logo: "Logo AI Kode Sherpa",
      name_example: "nome@esempio.com",
      password: "Password",
      enter_verification_code: "Inserisci Codice di Verifica",
      error_resetting_password:
        "Si è verificato un errore durante il reset della password",
      error_confirming_reset:
        "Si è verificato un errore durante la conferma del reset",
      change_password_required: "Cambio Password Obbligatorio",
      enter_new_password: "Inserisci una nuova password",
      please_enter_new_password: "Inserisci una nuova password",
      change_password: "Cambia Password",
      error_changing_password:
        "Si è verificato un errore durante il cambio password",
      password_change_denied:
        "Il cambio password è stato negato. Controlla i requisiti della password.",
      invalid_password:
        "La password non soddisfa i requisiti. Usa una password più forte.",
      password_requirements: "Requisiti della password:",
      password_min_length: "Almeno 8 caratteri",
      password_require_uppercase: "Una lettera maiuscola",
      password_require_lowercase: "Una lettera minuscola",
      password_require_number: "Un numero",
      password_require_special: "Un carattere speciale",
      password_missing_requirements:
        "La tua password non soddisfa i seguenti requisiti:",

      // ErrorPage strings
      go_to_login_page: "Vai alla pagina di login",

      // Sidebar strings
      toggle_menu: "Attiva/disattiva menu",
      ai_kode_sherpa: "AI Kode Sherpa",
      astrakode_logo: "Logo Astrakode",
      astrakode_favicon: "Favicon Astrakode",

      // MainLayout strings
      logout: "Esci",
      toggle_code_editor: "Attiva/disattiva Editor Codice",
      error_during_generation: "Errore durante la generazione, riprova!",
      not_compiled: "Non compilato",
      generation_failed: "Generazione fallita",
      starting_code_generation: "Avvio generazione codice...",
      generated: "Generato",
      idle: "Inattivo",
      fixing_errors_status: "Correzione errori...",
      failed_to_generate_project: "Impossibile generare il progetto. Riprova.",
      error_occurred_generating_unit_tests:
        "Si è verificato un errore durante la generazione dei test unitari",
      error_occurred_executing_unit_tests:
        "Si è verificato un errore durante l'esecuzione dei test unitari",
      loading: "Caricamento",

      // ChatComponent strings
      assistant_avatar: "Avatar Assistente",

      // Root.tsx strings
      app_title: "AI Kode Sherpa",

      // About page strings
      go_to_demo: "← Vai alla demo",
      about_react_router_contacts: "Informazioni sui Contatti React Router",
      demo_description:
        "Questa è un'applicazione demo che mostra alcune delle potenti funzionalità di React Router, incluso il routing dinamico, le rotte nidificate, i loader, le azioni e altro ancora.",
      features: "Funzionalità",
      explore_demo: "Esplora la demo per vedere come React Router gestisce:",
      data_loading_mutations:
        "Caricamento dati e mutazioni con loader e azioni",
      nested_routing: "Routing nidificato con relazioni genitore/figlio",
      url_based_routing: "Routing basato su URL con segmenti dinamici",
      pending_optimistic_ui: "UI pendente e ottimistica",
      learn_more: "Scopri di più",
      check_documentation: "Consulta la documentazione ufficiale su",
      reactrouter_link: "reactrouter.com",
      learn_more_description:
        "per saperne di più sulla creazione di ottime applicazioni web con React Router.",

      // Additional strings
      success_rate: "Tasso di Successo",
      compilation_results: "Risultati Compilazione",
      open_compilation_results: "Apri Risultati Compilazione",
      open_test_results: "Apri Risultati Test",
      this_may_take_a_few_moments: "Potrebbe richiedere alcuni minuti",
      fix_compilation_errors: "Correggi errori di compilazione",
      contract_compilation_failed: "Il contratto non compila",
      fixing_errors: "Correzione errori...",
      download_test_code: "Scarica codice test",

      // Tool descriptions
      tool_generateCode_description:
        "Generazione del codice basata sulle tue specifiche",
      tool_generateContract_description:
        "Generazione del codice basata sulle tue specifiche",
      tool_updateRequirements_description:
        "Aggiornamento dei requisiti e delle specifiche del progetto",
      tool_readFileTool_description: "Lettura dei file del progetto",
      tool_writeFileTool_description: "Creazione dei file del progetto",
      tool_updateFileTool_description: "Aggiornamento dei file del progetto",
      tool_deleteNodeTool_description: "Eliminazione di file o cartelle del progetto",
      tool_moveNodeTool_description: "Spostamento di file o cartelle del progetto",
      tool_listDirectoryTool_description: "Lettura della struttura del progetto",
      tool_generateDeploymentInstructions_description:
        "Generazione delle istruzioni di deployment per il contratto",
      tool_updateCode_description:
        "Aggiornamento del codice del contratto basato sulle tue specifiche",
      tool_retrieveContractCode_description: "Lettura del codice del contratto",
      tool_retrieveRequirements_description: "Lettura dei requisiti",
      tool_retrieveTests_description: "Lettura dei test",
      tool_working_description: "Elaborazione della richiesta",

      // Test strings
      generating_tests: "Generazione test in corso...",
      executing_tests: "Esecuzione test in corso...",
      generating_tests_for: "Generazione test per",
      running_tests_for: "Esecuzione test per",
      test_generation_failed:
        "Generazione dei test fallita, riprova più tardi. Se il problema persiste, contatta il supporto.",
      test_execution_failed:
        "Esecuzione dei test fallita, riprova più tardi. Se il problema persiste, contatta il supporto.",
      coverage_execution_failed:
        "La raccolta della copertura del codice è fallita, ma i risultati dell'esecuzione dei test sono comunque disponibili.",
      test_execution_timeout:
        "Timeout durante l'esecuzione dei test. I test stanno impiegando troppo tempo. Riprova con test più semplici o contatta il supporto.",
      test_compilation_failed:
        "Compilazione dei test fallita. Potrebbero esserci errori di sintassi nei test generati. Riprova o contatta il supporto.",
      test_missing_dependencies:
        "Esecuzione dei test fallita a causa di dipendenze mancanti. Riprova o contatta il supporto.",
      test_exec_fail_missing_permissions:
        "Esecuzione dei test fallita a causa di problemi di permessi. Riprova o contatta il supporto.",
      test_exec_fail_memory_constraints:
        "Esecuzione dei test fallita a causa di limiti di memoria. Riprova con test più semplici o contatta il supporto.",
      test_exec_fail_unexpectedly:
        "Esecuzione dei test fallita in modo imprevisto. Riprova più tardi o contatta il supporto se il problema persiste.",
      error_retrieving_tests:
        "Si è verificato un errore nel recupero dei test. Riprova.",

      upgrade_to_download: "Aggiorna a premium per scaricare progetti",
      upgrade_to_generate_tests: "Aggiorna a premium per generare test",
      generate_tests_for_file: "Genera test per {{file}}",
      regenerate_tests_for_file: "Rigenera test per {{file}}",
      select_solidity_file_to_generate:
        "Seleziona un file Solidity per generare i test",
      tests_will_target: "I test verranno generati per",
      active_contract: "Contratto attivo",
      tests_for: "Genera test per",
      regenerate: "Rigenera",
      generate: "Genera",
      generate_for_file: "Genera per {{file}}",
      no_file_selected: "Nessun file selezionato",
      context_mismatch_warning:
        "Il file aperto nell'editor ({{active}}) è diverso dal file per cui sono stati generati questi test.",
      upgrade_plus_title: "Sblocca le Funzionalità Premium",
      upgrade: "Upgrade",
      upgrade_plan: "Passa a Plus",

      // Token / subscription modals
      token_limit_exceeded: "Limite token superato",
      insufficient_tokens: "Token insufficienti",
      insufficient_tokens_description:
        "Non hai abbastanza token per completare questa operazione.",
      tokens_needed: "Token richiesti:",
      tokens_remaining: "Token rimanenti:",
      upgrade_plus_get: "Passa al Piano Plus e ottieni:",
      tokens_per_month: "3M token/mese",
      ten_x_more: "10 volte in più del piano gratuito!",
      upgrade_now: "Passa a Plus",
      token_limit_exceeded_title: "Limite token superato",
      token_limit_exceeded_message:
        "Limite token superato. Passa a un piano superiore o attendi la data di reset per continuare.",
      used: "Usati:",
      used_label: "Usati",
      limit: "Limite:",
      remaining: "Rimanenti:",
      remaining_label: "Rimanenti",
      resets_on: "Si resetta il:",
      upgrade_plan: "Passa al piano",
      billing_subscription: "Fatturazione e abbonamento",
      current_plan: "Piano attuale",
      account_email: "Email dell'account",
      plan_valid_until: "Piano valido fino al",
      next_billing_date: "Prossima fatturazione",
      downgrading_to: "Passaggio al piano",
      plan_status: "Stato piano",
      unlimited: "Illimitato",
      service_plan_unlimited: "Piano di servizio con accesso illimitato",
      service_plan: "Piano di servizio",
      free_plan: "Piano gratuito",
      plus_plan: "Piano Plus",
      upgrade_to_plus: "Passa a Plus",
      manage_subscription: "Gestisci abbonamento",
      your_plan_includes: "Il tuo piano include:",
      service_plan_managed: "Piano di servizio gestito amministrativamente",
      upgrade_to_plus_plan: "Passa al Piano Plus",
      monthly: "Mensile",
      yearly: "Annuale",
      save_20: "Risparmia 20%",
      tax_at_checkout: "Imposte calcolate al checkout",
      million_tokens_per_month: "15 milioni di token al mese",
      advanced_code_generation: "Generazione codice avanzata",
      enhanced_testing: "Funzionalità di test avanzate",
      priority_support: "Supporto prioritario",
      cancel_anytime: "Annulla quando vuoi",
      processing: "Elaborazione...",
      continue_to_checkout: "Vai al checkout",
      token_usage: "Utilizzo token",
      close_modal: "Chiudi modale",
      total_limit: "Limite totale",
      tokens_label: "token",
      status_label: "Stato: ",
      token_limit_warning_exceeded:
        "Hai superato il limite di token. Passa a un piano superiore o attendi la data di reset.",
      token_limit_warning_low:
        "Stai esaurendo i token. Valuta di passare a un piano superiore.",
      token_limit_warning_most:
        "Hai utilizzato la maggior parte della tua quota di token questo mese.",
      delete_project: "Elimina Progetto",
      project_deleted: "Progetto Eliminato",
      project_deleted_success: "Il progetto è stato rimosso con successo.",
      delete_failed: "Eliminazione fallita",
      delete_failed_error: "Si è verificato un errore durante l'eliminazione del progetto. Riprova.",
      confirm_delete_project: "Sei sicuro di voler eliminare questo progetto? L'azione non può essere annullata.",
    },
  },
  zh: {
    translation: {
      chat_starting_message:
        "再見！ 😊 很高興在這裡見到你。今天我能為您提供什麼幫助？如果您有特定的應用程式或問題，請隨時分享概述，我們可以一起開始探索！",
      chat_ready_to_generate:
        "如果您對目前的描述感到滿意並希望停止進行進一步的更改，您可以透過按下下面的按鈕來產生程式碼。",
      start_discussing_your_idea: "開始討論您的想法",
      chat_generate_code: "產生",
      chat_generation_system_prompt:
        "您的請求正在處理中。合約將在側邊欄中顯示。",
      generating_code: "產生中...",
      chat_input_text: "寫下你的訊息...",
      home: "Home",
      history: "History",
      about: "About",
      no_more_seats_title: "⚠️ 您已達到免費合約生成限制",
      authentication_error:
        "⚠️ 您的憑證出現問題，請聯繫客服！",
      no_more_seats_description:
        "您已成功使用 AI Kode Sherpa 生成 5 個智能合約！",
      no_more_seats_description2: "🎉 想要更多嗎？我們很樂意繼續幫助您！🚀",
      no_more_seats_description3:
        "點擊下方申請更多免費座位，我們的團隊將會聯繫您以協助您。",
      no_more_seats_button: "申請更多免費座位",
      seats_request_success_title: "謝謝，您的申請已成功處理。",
      seats_request_success_description: "我們的團隊將會聯繫您以協助您。",
      contact_support: "聯繫支持",
      support_email_label: "電子郵件",
      support_discord_label: "Discord",
      create_account: "創建帳戶",
      start_coding: "使用 Kode Sherpa 開始編程",
      signup_tagline: "免費註冊 · 無需信用卡 · 約30秒",
      go_back: "返回",
      sign_in_with: "登錄",
      sign_up_with: "註冊",
      sign_in: "登錄",
      sign_up: "註冊",
      already_have_account: "已經有帳戶了嗎？",
      not_have_account: "還沒有帳戶嗎？",
      or: "或者",
      accept_terms_and_privacy_policy: "接受服務條款和隱私政策",
      terms_of_service: "服務條款",
      privacy_policy: "隱私政策",
      loading: "加載中...",
      send: "發送",
      close: "關閉",
      verify: "驗證",
      resend: "重發",
      forgot_password: "忘記密碼？",
      reset_password: "重設密碼",
      enter_email_to_reset: "輸入您的電子郵件以接收驗證碼",
      send_reset_code: "發送重設碼",
      enter_reset_code: "請輸入重設密碼的驗證碼",
      verification_code_from_email: "電子郵件收到的驗證碼",
      enter_code_sent_to_email: "請輸入我們發送到您電子郵件的驗證碼",
      choose_new_password: "請選擇符合以下要求的新密碼",
      new_password: "新密碼",
      confirm_new_password: "確認新密碼",
      verification_code: "請輸入驗證碼",
      reset_code_sent: "重設密碼驗證碼已發送",
      please_enter_email: "請輸入您的電子郵件",
      please_enter_code_and_password: "請輸入驗證碼和密碼",
      reset_password_after_failed_attempts:
        "我們注意到多次登錄失敗。請重設密碼或嘗試使用 Google 登錄",
      reset_password_technical_required:
        "為了確保與新版本相容，請輸入寄送到您電子郵件的驗證碼以重設密碼。這是計畫中的技術升級，並非錯誤。",
      reset_code_sent: "重設密碼驗證碼已發送",
      password_reset_success: "密碼重設成功",
      user_does_not_exist: "用戶不存在",
      error_during_password_reset: "重設密碼時發生錯誤。請重試。",
      incorrect_credentials: "電子郵件或密碼不正確。",
      account_exists_reset_password:
        "此電子郵件已有帳戶。請使用電子郵件和密碼或 Google 登錄。",
      code_resent: "驗證碼已重新發送",
      resend_verification_code: "重新發送驗證碼",
      check_email_for_code: "請查看您的電子郵件以獲取驗證碼",
      auth_failed_try_again: "驗證失敗，請重試。",
      sign_in_google_failed: "使用 Google 登錄失敗，請重試。",
      sign_up_google_failed: "使用 Google 註冊失敗，請重試。",
      oauth_error: "使用 Google 登錄失敗，請重試。",
      session_error_sign_in_again: "會話錯誤，請重新登錄。",
      error_during_sign_in: "登錄時發生錯誤，請重試。",
      captcha_not_available: "無法載入驗證，請刷新頁面後重試。",
      error_during_sign_up: "註冊時發生錯誤，請重試。",
      auth_failed_sign_in_manually: "驗證失敗，請手動登錄。",
      error_during_verification: "驗證時發生錯誤，請重試。",
      wrong_verification_code: "驗證碼不正確，請重試。",
      verification_code_expired: "驗證碼已過期，請重新獲取。",
      error_resending_code: "重新發送驗證碼時發生錯誤，請重試。",
      error_contact_support: "發生錯誤 (錯誤代碼：{{errorCode}})，請聯繫客服。",
      password_reset_success_sign_in: "密碼重設成功，請使用新密碼登錄。",
      oauth_domain_not_configured: "Google 登錄暫不可用，請稍後重試。",
      attempt_remaining_before_reset: "還剩 1 次嘗試即可使用密碼重設。",
      attempts_remaining_before_reset: "還剩 {{count}} 次嘗試即可使用密碼重設。",
      created_at: "創建於",
      last_update: "最後更新",
      open_chat: "開啟聊天",
      open_project: "開啟項目",
      no_items_found: "找不到任何元素",
      loading_more_items: "加載元素...",
      new_chat: "新聊天",
      new_project: "新項目",
      current_project: "當前項目",
      templates: "模板",
      projects: "項目",
      profile: "個人資料",
      my_projects: "我的項目",
      search_projects_placeholder: "按名稱或描述搜索項目...",
      view_details: "查看詳情 →",
      summary: "摘要",
      created: "創建於",
      updated: "更新於",
      project_id: "項目 ID",
      open_studio: "打開工作室",
      tokens_used: "已使用 token",
      tokens_generated: "已生成 token",
      chat_tokens: "聊天 Token",
      generated_tokens: "生成 Token",
      go_to_last_message: "前往最後一條消息",

      // Root.tsx strings
      loading_please_wait: "正在載入，請稍候...",
      oops: "哎呀！",
      unexpected_error: "發生了意外錯誤。",
      page_not_found: "找不到請求的頁面。",
      error: "錯誤",

      // Profile page
      profile_loading: "正在載入您的個人資料...",
      profile_data_updating: "數據正在更新...",
      profile_error_title: "載入個人資料時發生錯誤",
      profile_retry: "重試",
      profile_title: "帳戶資料",
      profile_subtitle: "管理您的訂閱、查看代幣使用情況並更新帳戶設定。",

      // LoginModal strings
      sign_in_to_continue: "登錄以繼續",
      create_account_or_sign_in: "創建帳戶或登錄以發送消息",
      sign_in_button: "登錄",
      sign_up_for_free: "免費註冊",

      // CodeEditor strings
      undo: "撤銷",
      redo: "重做",
      copy_to_clipboard: "複製到剪貼板",
      download_project: "下載專案",
      open_in_remix_ide: "在 Remix IDE 中打開",
      compile_code: "編譯代碼",
      compile_project: "編譯專案",
      generate_unit_tests: "生成單元測試",
      updating_code: "更新代碼",
      feature_not_available: "此功能在您當前的計劃中不可用。升級以訪問此功能。",
      locked_file_read_only: "此檔案已鎖定，無法編輯。",
      editor_read_only: "編輯器為唯讀模式。",

      // CompilationModal strings
      compiling: "編譯中...",
      compilation_logs: "編譯日誌：",
      fix_errors: "修復錯誤",
      fixing: "修復中...",
      no_compilation_status: "沒有編譯狀態",
      no_errors_found: "未發現錯誤",
      fix_errors_failed: "我無法修復所有錯誤。請檢查代碼並手動修復錯誤。",

      // UnitTestResultsModal strings
      generating_unit_tests: "生成單元測試中...",
      this_may_take_moments: "這可能需要幾分鐘時間",
      to_be_tested: "待測試",
      unit_test_results: "單元測試結果",
      total_tests: "總測試數",
      passed: "通過",
      failed: "失敗",
      skipped: "跳過",
      excellent: "優秀",
      good: "良好",
      needs_improvement: "需要改進",
      code_coverage: "代碼覆蓋率",
      statements: "語句",
      branches: "分支",
      functions: "函數",
      lines: "行數",
      execution_time: "執行時間",
      warnings: "警告",
      recommendations: "建議",
      generated_test_code: "生成的測試代碼：",
      download: "下載",

      // DownloadConfirmationModal strings
      download_hardhat_project: "下載 Hardhat 專案",
      download_project_description:
        "下載預配置的 Hardhat 專案資料夾，包含部署和測試合約的完整設置，使用以下選項之一：",
      code_existing_tests: "代碼 + 現有測試",
      code_new_tests: "代碼 + 新測試",
      code_simplified_tests: "代碼 + 簡化測試",
      cancel: "取消",
      download_error: "下載錯誤",
      try_again: "重試",
      download_generated_correctly: "下載生成成功！",
      download_success_message: "您的下載已正確生成。選擇保存位置。",
      click_outside_to_close: "點擊模態框外部關閉並檢查下載。",
      preparing_download: "準備下載中...",
      preparing_download_message: "請稍候，我們正在為您準備專案下載",
      download_will_start_automatically: "測試準備好後將自動開始下載。",

      // HistoryComponent strings
      no_summary_available: "沒有可用摘要。",

      // Notification strings
      hidden_notifications: "隱藏通知",
      studio_autosave_failed: "檔案自動儲存失敗",
      studio_create_file_failed: "建立檔案失敗",
      studio_create_folder_failed: "建立資料夾失敗",
      studio_delete_node_failed: "刪除檔案失敗",
      studio_rename_node_failed: "重新命名檔案失敗",
      studio_move_node_failed: "移動檔案失敗",

      // SignInSignUpPage strings
      ai_kode_sherpa_logo: "AI Kode Sherpa 標誌",
      name_example: "姓名@例子.com",
      password: "密碼",
      enter_verification_code: "輸入驗證碼",
      error_resetting_password: "重設密碼時發生錯誤",
      error_confirming_reset: "確認重設時發生錯誤",
      change_password_required: "需要更改密碼",
      enter_new_password: "請輸入新密碼",
      please_enter_new_password: "請輸入新密碼",
      change_password: "更改密碼",
      error_changing_password: "更改密碼時發生錯誤",
      password_change_denied: "密碼更改被拒絕。請檢查您的密碼要求。",
      invalid_password: "密碼不符合要求。請使用更強的密碼。",
      password_requirements: "密碼要求：",
      password_min_length: "至少8個字符",
      password_require_uppercase: "一個大寫字母",
      password_require_lowercase: "一個小寫字母",
      password_require_number: "一個數字",
      password_require_special: "一個特殊字符",
      password_missing_requirements: "您的密碼缺少以下要求：",

      // ErrorPage strings
      go_to_login_page: "前往登錄頁面",

      // Sidebar strings
      toggle_menu: "切換菜單",
      ai_kode_sherpa: "AI Kode Sherpa",
      astrakode_logo: "Astrakode 標誌",
      astrakode_favicon: "Astrakode 圖標",

      // MainLayout strings
      logout: "登出",
      toggle_code_editor: "切換代碼編輯器",
      error_during_generation: "生成過程中出錯，請重試！",
      not_compiled: "未編譯",
      generation_failed: "生成失敗",
      starting_code_generation: "開始代碼生成...",
      generated: "已生成",
      idle: "空閒",
      fixing_errors_status: "修復錯誤中...",
      failed_to_generate_project: "無法生成專案。請重試。",
      error_occurred_generating_unit_tests: "生成單元測試時發生錯誤",
      error_occurred_executing_unit_tests: "測試執行期間發生錯誤",
      fixing_errors_status: "修復錯誤中...",
      loading: "加載中",

      // ChatComponent strings
      assistant_avatar: "助手頭像",

      // Root.tsx strings
      app_title: "AI Kode Sherpa",

      // About page strings
      go_to_demo: "← 前往演示",
      about_react_router_contacts: "關於 React Router 聯繫人",
      demo_description:
        "這是一個演示應用程序，展示了 React Router 的一些強大功能，包括動態路由、嵌套路由、加載器、操作等。",
      features: "特性",
      explore_demo: "探索演示以了解 React Router 如何處理：",
      data_loading_mutations: "使用加載器和操作進行數據加載和變更",
      nested_routing: "具有父子關係的嵌套路由",
      url_based_routing: "基於 URL 的動態段路由",
      pending_optimistic_ui: "待處理和樂觀 UI",
      learn_more: "了解更多",
      check_documentation: "查看官方文檔",
      reactrouter_link: "reactrouter.com",
      learn_more_description:
        "以了解更多關於使用 React Router 構建優秀 Web 應用程序的信息。",

      // Additional strings
      success_rate: "成功率",
      compilation_results: "編譯結果",
      open_compilation_results: "打開編譯結果",
      open_test_results: "打開測試結果",
      this_may_take_a_few_moments: "這可能需要幾分鐘時間",
      fix_compilation_errors: "修復編譯錯誤",
      contract_compilation_failed: "合約無法編譯",
      fixing_errors: "修復錯誤中...",
      download_test_code: "下載測試代碼",

      // Tool descriptions
      tool_generateCode_description: "根據您的規格生成代碼",
      tool_generateContract_description: "根據您的規格生成代碼",
      tool_updateRequirements_description: "更新項目需求和規格",
      tool_readFileTool_description: "讀取專案檔案",
      tool_writeFileTool_description: "建立專案檔案",
      tool_updateFileTool_description: "更新專案檔案",
      tool_deleteNodeTool_description: "刪除專案檔案或資料夾",
      tool_moveNodeTool_description: "移動專案檔案或資料夾",
      tool_listDirectoryTool_description: "讀取專案結構",
      tool_generateDeploymentInstructions_description: "為合約生成部署說明",
      tool_updateCode_description: "根據您的規格更新合約代碼",
      tool_retrieveContractCode_description: "讀取合約代碼",
      tool_retrieveRequirements_description: "讀取需求",
      tool_retrieveTests_description: "讀取測試",
      tool_working_description: "正在處理您的請求",

      // Test strings
      generating_tests: "正在生成測試...",
      executing_tests: "正在執行測試...",
      generating_tests_for: "正在為以下檔案生成測試：",
      running_tests_for: "正在為以下檔案執行測試：",
      test_generation_failed:
        "測試生成失敗，請稍後重試。如果問題持續，請聯繫客服。",
      test_execution_failed:
        "測試執行失敗，請稍後重試。如果問題持續，請聯繫客服。",
      coverage_execution_failed:
        "程式碼覆蓋率收集失敗，但測試執行結果仍然可用。",
      test_execution_timeout:
        "測試執行逾時。測試耗時過久。請嘗試使用更簡單的測試或聯繫客服。",
      test_compilation_failed:
        "測試編譯失敗。生成的測試可能有語法錯誤。請重試或聯繫客服。",
      test_missing_dependencies: "測試執行因缺少依賴而失敗。請重試或聯繫客服。",
      test_exec_fail_missing_permissions:
        "測試執行因權限問題而失敗。請重試或聯繫客服。",
      test_exec_fail_memory_constraints:
        "測試執行因記憶體限制而失敗。請使用更簡單的測試或聯繫客服。",
      test_exec_fail_unexpectedly:
        "測試執行意外失敗。請稍後重試或聯繫客服，如問題持續。",
      error_retrieving_tests: "取得測試時發生錯誤，請重試。",

      upgrade_to_download: "升級至進階方案以下載專案",
      upgrade_to_generate_tests: "升級至進階方案以生成測試",
      generate_tests_for_file: "為 {{file}} 生成測試",
      regenerate_tests_for_file: "為 {{file}} 重新生成測試",
      select_solidity_file_to_generate: "選擇一個 Solidity 檔案以生成測試",
      tests_will_target: "將為以下檔案生成測試：",
      active_contract: "目前合約",
      tests_for: "為以下檔案生成測試：",
      regenerate: "重新生成",
      generate: "生成",
      generate_for_file: "為 {{file}} 生成",
      no_file_selected: "未選擇檔案",
      context_mismatch_warning:
        "編輯器目前的檔案 ({{active}}) 與這些測試生成時使用的檔案不同。",
      upgrade_plus_title: "解鎖進階功能",
      upgrade: "Upgrade",
      upgrade_plan: "升級至 Plus",

      // Token / subscription modals
      token_limit_exceeded: "已超出 token 限制",
      insufficient_tokens: "Token 不足",
      insufficient_tokens_description: "您的 token 不足以完成此操作。",
      tokens_needed: "所需 token：",
      tokens_remaining: "剩餘 token：",
      upgrade_plus_get: "升級至 Plus 方案可獲得：",
      tokens_per_month: "每月 1500 萬 token",
      ten_x_more: "比免費方案多 10 倍！",
      upgrade_now: "立即升級",
      token_limit_exceeded_title: "已超出 Token 限制",
      token_limit_exceeded_message:
        "已超出 token 限制。請升級方案或等待重置日期後繼續。",
      used: "已使用：",
      used_label: "已使用",
      limit: "限制：",
      remaining: "剩餘：",
      remaining_label: "剩餘",
      resets_on: "重置於：",
      upgrade_plan: "升級方案",
      billing_subscription: "帳單與訂閱",
      current_plan: "當前方案",
      account_email: "帳戶電子郵件",
      plan_valid_until: "方案有效期至",
      next_billing_date: "下次帳單日期",
      downgrading_to: "降級至",
      plan_status: "方案狀態",
      unlimited: "無限制",
      service_plan_unlimited: "服務方案享有無限存取",
      service_plan: "服務方案",
      free_plan: "免費方案",
      plus_plan: "Plus 方案",
      upgrade_to_plus: "升級至 Plus",
      manage_subscription: "管理訂閱",
      your_plan_includes: "您的方案包含：",
      service_plan_managed: "服務方案由管理員管理",
      upgrade_to_plus_plan: "升級至 Plus 方案",
      monthly: "月付",
      yearly: "年付",
      save_20: "省 20%",
      tax_at_checkout: "結帳時計算稅額",
      million_tokens_per_month: "每月 1500 萬 token",
      advanced_code_generation: "進階代碼生成",
      enhanced_testing: "進階測試功能",
      priority_support: "優先支援",
      cancel_anytime: "隨時取消",
      processing: "處理中...",
      continue_to_checkout: "前往結帳",
      token_usage: "Token 使用量",
      close_modal: "關閉視窗",
      total_limit: "總限額",
      tokens_label: "token",
      status_label: "狀態：",
      token_limit_warning_exceeded:
        "您已超出 token 限制。請升級方案或等待重置日期。",
      token_limit_warning_low:
        "您的 token 即將用盡。請考慮升級方案。",
      token_limit_warning_most:
        "您本月已使用大部分 token 配額。",
      delete_project: "刪除項目",
      project_deleted: "項目已刪除",
      project_deleted_success: "項目已成功移除。",
      delete_failed: "刪除失敗",
      delete_failed_error: "刪除項目時發生錯誤。請重試。",
      confirm_delete_project: "您確定要刪除此項目嗎？此操作無法撤回。",
    },
  },
};

//Get the user language
let userLanguage = "en";
if (typeof window !== "undefined") {
  userLanguage = navigator.language.split("-")[0];
}

i18n.use(initReactI18next).init({
  resources,
  lng: resources[userLanguage] ? userLanguage : "en", // Use the browser language if available, otherwise fallback to 'en'
  fallbackLng: "en",
  interpolation: {
    escapeValue: false,
  },
});

export default i18n;
